import React from 'react';
import { BookingsList } from './pages/bookingsListPage';
import { FlownBookingsList } from './pages/flownBookingsListPage';
import { Loyalty } from './pages/loyaltyPage';
import { SharingTokenAwareRoute } from 'acscp/components/sharingTokenAwareRoute';
import { Trip } from './pages/tripPage';
import { QuoteAcceptPage } from './pages/quoteAcceptPage';
import { Redirect, Route } from 'react-router';
import {
    CreateAccount,
    Login,
    LoginOrCreateAccount
} from 'acscp/components/pages/loginOrCreateAccount';
import { ForgottenPasswordPage } from 'acscp/components/pages/forgottenPasswordPage';
import { CreatePassword, ResetPassword } from 'acscp/components/pages/passwordReset';
import { LoyaltyTermsAndConditions } from './pages/loyaltyTermsAndConditions';
import { EditFlightRequest, NewFlightRequest, RepeatFlightRequest } from './pages/flightRequestPage';
import { VerifyAccountPage } from './pages/verifyAccountPage';
import { FlightRequestSubmittedPage } from 'acscp/components/pages/flightRequestSubmittedPage';
import { AcceptAccountLink } from 'acscp/components/pages/acceptAccountLink';
import {
    LoyaltySchemeLogin,
    LoyaltySchemeRequestAccount
} from 'acscp/components/pages/loginOrRequestLoyaltySchemeAccount';
import { withPageLayout } from 'acscp/components/layout/pageLayout';
import { FlightsListPage } from 'acscp/mobile/components/pages/flightsListPage';

export const sharedRoutes = [
    (<SharingTokenAwareRoute key="trip" path="/trip" exact={true} component={BookingsList} />),
    (<SharingTokenAwareRoute key="tripFlown" path="/tripFlown" exact={true} component={FlownBookingsList} />),
    (
        <SharingTokenAwareRoute
            key="trip/:bookingId/quotes/:quoteId/accept"
            path="/trip/:bookingId/quotes/:quoteId/accept"
            exact={true}
            component={QuoteAcceptPage}
        />
    ),
    // Note this is _not_ an exact match to allow nested routes beneath it for modals.
    (<SharingTokenAwareRoute key="trip/:bookingId" path="/trip/:bookingId" component={Trip} />),
    (
        <Route
            key="loyalty/terms-and-conditions"
            path="/loyalty/terms-and-conditions"
            exact={true}
            component={LoyaltyTermsAndConditions}
        />
    ),
    // Note this is _not_ an exact match to allow nested routes beneath it for modals.
    (<Route key="loyalty" path="/loyalty" exact={false} component={Loyalty} />),
    (
        <Route
            key="flight-requests/new"
            path="/flight-requests/new"
            exact={true}
            component={NewFlightRequest}
        />
    ),
    (
        <Route
            key="flight-requests/thank-you"
            path="/flight-requests/thank-you"
            exact={true}
            component={FlightRequestSubmittedPage}
        />
    ),
    (
        <Route
            key="flight-requests/:flightRequestId"
            path="/flight-requests/:flightRequestId"
            exact={true}
            component={EditFlightRequest}
        />
    ),
    (
        <Route
            key="flight-requests/:flightRequestId/repeat-request"
            path="/flight-requests/:flightRequestId/repeat-request"
            exact={true}
            component={RepeatFlightRequest}
        />
    ),
    (
        <Route
            key="login"
            path="/login"
            exact={true}
            component={USE_MOBILE_APP_LOGIN_PAGE ? Login : LoginOrCreateAccount}
        />
    ),
    (
        <Route
            key="create-account"
            path="/create-account"
            exact={true}
            component={USE_MOBILE_APP_LOGIN_PAGE ? CreateAccount : LoginOrCreateAccount}
        />
    ),
    (
        <Route
            key="login-my-rewards"
            path="/login-my-rewards"
            exact={true}
            component={ENABLE_MY_REWARDS_LOGIN_PAGE ? LoyaltySchemeLogin : () => <Redirect to={'/login'} />}
        />
    ),
    (
        <Route
            key="request-account-my-rewards"
            path="/request-account-my-rewards"
            exact={true}
            component={ENABLE_MY_REWARDS_LOGIN_PAGE ? LoyaltySchemeRequestAccount : () => <Redirect to={'/create-account'} />}
        />
    ),
    (<Route key="forgotten-password" path="/forgotten-password" exact={true} component={ForgottenPasswordPage} />),
    (<Route key="create-password" path="/create-password" exact={true} component={CreatePassword} />),
    (<Route key="reset-password" path="/reset-password" exact={true} component={ResetPassword} />),
    (<Route key="verify-account" path="/verify-account" exact={true} component={VerifyAccountPage} />),
    (
        <Route
            key="accept-account-link/:acceptAccountLinkToken"
            path="/accept-account-link/:acceptAccountLinkToken"
            exact={true}
            component={AcceptAccountLink}
        />
    ),
];
